<template>

  <div>
    <div class="autocomplete d-flex align-center">
      <v-autocomplete :value="value"
                      @input="change($event)"
                      :items="options"
                      :label="_label"
                      :menu-props="{ auto: true }"
                      :multiple="multiple"
                      :small-chips="multiple"
                      :deletable-chips="multiple"
                      item-text="displayName"
                      item-value="id"
      />

      <div class="icon" v-if="value">
        <v-btn text icon @click="clear()" v-if="clearable">
          <v-icon>delete</v-icon>
        </v-btn>
      </div>
    </div>
  </div>

</template>

<script>
  export default {
    name: 'users-select',

    props: [ 'value', 'label', 'clearable', 'multiple', 'filter' ],

    data () {
      return {
        users: []
      }
    },

    computed: {
      _label () {
        return this.label || this.$t('entityNames.users')
      },

      options () {
        return this.users.filter(item => !this.filter || !!this.filter(item))
      }
    },

    methods: {
      change (id) {
        this.$emit('input', id)
        this.$emit('change', id)
      },

      clear () {
        this.$emit('input', null)
      }
    },

    async created () {
      if (!this.$store.state.items['users'].length)
        await this.$store.dispatch('getItems', { model: { name: 'users' } })

      this.users = this.$store.state.items['users']
    },
  }
</script>

<style scoped lang="scss">

</style>
